import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import Link from 'react-router-dom/Link';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

function ItemIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [loading, setLoading] = useState(false);

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        fetchtableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search

    useEffect(() => {
        if (!searchTerm.trim()) {
            setFilteredData(data); // Reset filteredData if searchTerm is empty
        } else {
            const filtered = data.filter(item =>
                item.name?.toLowerCase().includes(searchTerm.toLowerCase()) // Corrected small n
            );
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);
    
    
    const fetchtableData = async () => {
        fetchData('ItemApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                    setFilteredData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Supplier Details:', error);
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('ItemApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemApi', `${itemId}`, token)
            .then(() => {
                fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Item</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div>
                            <CircularProgress style={{ color: 'white' }} />
                            <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                        </div>
                    </div>
                )}
                <div className='mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        style={{ height: '26px', marginRight: '8px', marginLeft: '5px' }}
                    />
                </div>
                {hasCreateMasterPermission && (

                    <Tooltip title="Item Registration">

                        <Button
                            style={{ backgroundColor: 'rgb(12, 151, 125)', color: 'white', height: '26px', marginRight: '8px', marginLeft: '5px' }}
                            className="linkcolor"
                            component={Link}
                            to="/ItemCreate"
                        >
                            Create
                        </Button>

                    </Tooltip>
                )}
            </div>

            <div className="watermark" >
                <CopyrightIcon /><b style={{ fontFamily: 'serif' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className='mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#123458' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>HSN Code</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>GST %</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Rate</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Opening Stock</TableCell>
                                <TableCell sx={{ backgroundColor: '#123458', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out'
                                    }}
                                >
                                    <TableCell sx={{ padding: '3px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{item.itemCode}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{item.name}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{item.hsnCode}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{(item.gstRate)}%</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{item.rate}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>{item.openingStock}</TableCell>
                                    <TableCell sx={{ padding: '3px' }}>
                                        {hasEditMasterPermission && (
                                            <Link to={`/ItemEdit/${item.id}`}>
                                                <IconButton color="primary">
                                                    <EditIcon />
                                                </IconButton>
                                            </Link>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))} color="error">
                                                {item.isActive ? <DeleteIcon /> : <ActivateIcon />}
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default ItemIndex;

